import React, { useMemo, useState, useEffect } from 'react'
import Select from 'react-select'

const parseOptions = (options) => {
  return (options || {}).map((option) => {
    return { 
      value: option.value || option.id, 
      label: option.label || option.name 
    }
  })
}

const findOption = (id_or_obj, options) => {
  return options.find(
    (option) => option.value === (
      id_or_obj?.id || 
      id_or_obj?.value ||
      id_or_obj
    )
  )
}

export default (props) => {
  const options = useMemo(() => parseOptions(props.options), [props.options])
  const [selectedOption, setSelectedOption] = useState(findOption(props.selected, options));

  const handleSelect = (e) => setSelectedOption(e.value.id)

  useEffect(() => setSelectedOption(findOption(props.selected, options)), [props.selected])

  return <Select 
    options={options} 
    name={props.name} 
    value={selectedOption}
    onChange={handleSelect}
  />
}